import { Link } from "react-router-dom";
import logoImg from "@/assets/logo-hitchef.png";

const seoLinks = [
  { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
  { path: "/pesnya-v-podarok", label: "Песня в подарок" },
  { path: "/pesnya-na-svadbu", label: "Песня на свадьбу" },
  { path: "/pesnya-na-yubiley", label: "Песня на юбилей" },
  { path: "/pesnya-pro-druga", label: "Песня про друга" },
  { path: "/pesnya-devushke-v-podarok", label: "Песня девушке" },
  { path: "/pesnya-mame-v-podarok", label: "Песня маме" },
  { path: "/pesnya-na-godovshchinu", label: "На годовщину" },
  { path: "/pesnya-kollege-v-podarok", label: "Песня коллеге" },
  { path: "/pesnya-rebenku-v-podarok", label: "Песня ребёнку" },
  { path: "/pesnya-dlya-vecherinki", label: "Для вечеринки" },
  { path: "/pesnya-na-vypusknoj", label: "На выпускной" },
  { path: "/originalnyi-podarok", label: "Оригинальный подарок" },
  { path: "/pozdravlenie-v-stihah", label: "Поздравление в стихах" },
];

const Footer = () => {
  return (
    <footer className="py-10 border-t border-border">
      <div className="container px-4 mx-auto">
        {/* SEO links grid */}
        <nav className="mb-8">
          <h3 className="font-display text-sm font-bold text-foreground mb-3">Персональные песни</h3>
          <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-4 gap-y-1.5 text-xs text-muted-foreground">
            {seoLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="hover:text-foreground transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-border">
          <div className="flex items-center gap-2">
            <img src={logoImg} alt="Хит Шеф" className="w-6 h-6 rounded-md object-cover" width={24} height={24} loading="lazy" />
            <span className="font-display text-base font-bold text-foreground">Хит Шеф</span>
          </div>

          <nav className="flex items-center gap-5 text-sm text-muted-foreground">
            <a href="#how-it-works" className="hover:text-foreground transition-colors">Как работает</a>
            <a href="#faq" className="hover:text-foreground transition-colors">FAQ</a>
            <a href="https://t.me/hitchef_support" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">Поддержка</a>
          </nav>

          <p className="text-xs text-muted-foreground">
            © 2026 Хит Шеф
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
